import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=66357e9e&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&id=66357e9e&prod&scoped=true&lang=less&"
import style1 from "./pagination.vue?vue&type=style&index=1&id=66357e9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66357e9e",
  null
  
)

export default component.exports